<div class="blog-area-wrap">
  <div class="container" infiniteScroll
  [infiniteScrollDistance]="8"
  [infiniteScrollThrottle]="500"
  [alwaysCallback]="true"
  (scrolled)="onScroll($event)">
    <div class="row">
      <div class="col-sm col-md-4 col-lg-3" *ngIf="isFilterVisible"> <!--add class "filter-visible" on filter button click-->
        <div class="inner-wrap-blogcategory">
          <h3 class="sec-title">Categories</h3>
          <ul class="category-listing list-unstyled">
            <li
              *ngFor="let item of categoryList"
              class="ct-list-item pointer"
              [ngClass]="{ categorySelected: this.category == item.slug }"
            >
              <a (click)="categoryListItem(item.slug)" class="ct-item">{{
                item.name
              }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mobile-filter-btn" (click)="toggleFilterView()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
          *ngIf="!isFilterVisible">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0 2.94184C0 2.64254 0.249888 2.3999 0.55814 2.3999H15.4419C15.7501 2.3999 16 2.64254 16 2.94184C16 3.24114 15.7501 3.48377 15.4419 3.48377H0.55814C0.249888 3.48377 0 3.24114 0 2.94184ZM2.48062 7.9999C2.48062 7.7006 2.73051 7.45797 3.03876 7.45797H12.9612C13.2695 7.45797 13.5194 7.7006 13.5194 7.9999C13.5194 8.29921 13.2695 8.54184 12.9612 8.54184H3.03876C2.73051 8.54184 2.48062 8.29921 2.48062 7.9999ZM5.45736 13.058C5.45736 12.7587 5.70725 12.516 6.0155 12.516H9.9845C10.2927 12.516 10.5426 12.7587 10.5426 13.058C10.5426 13.3573 10.2927 13.5999 9.9845 13.5999H6.0155C5.70725 13.5999 5.45736 13.3573 5.45736 13.058Z"
            fill="black" />
        </svg>
        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg"
        *ngIf="isFilterVisible">
          <path d="M12.7895 0.208422C12.5072 -0.069474 12.0483 -0.069474 11.766 0.208422L4.57407 7.28856L1.23398 4.00039C0.951692 3.72249 0.492753 3.72249 0.210468 4.00039C-0.0701557 4.27665 -0.0701559 4.72335 0.210467 4.99961L4.06232 8.79158C4.3446 9.06947 4.80354 9.06947 5.08583 8.79158L12.7895 1.20764C13.0702 0.93138 13.0702 0.484683 12.7895 0.208422Z" fill="black"/>
        </svg>        
        {{ !isFilterVisible ? "Filter" : "Apply"}}
      </div>

      <div class="col-sm col-md-8 col-lg-9">
        <div class="row row-wrap-card">
          <div
            class="col-sm col-md-6 col-lg-4"
            *ngFor="let category of categoryData"
          >
            <div class="wrap-card-blog">
              <app-blog-img-card [category]="category"></app-blog-img-card>
              <a href="/blogs/{{ category.slug }}" class="title">{{
                category.title.rendered
              }}</a>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
